/**
 * Deterministic avatar gradient picker.
 *
 * Hashes a member id into one of a small palette of "nice" linear
 * gradients so each member gets a stable, recognisable colour without
 * any backend coupling. Pure utility — safe to import from any
 * subcomponent and keep avatars in sync across the page.
 */
const GRADIENTS: string[] = [
  'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
  'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
  'linear-gradient(135deg, #f59e0b 0%, #b45309 100%)',
  'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
  'linear-gradient(135deg, #ec4899 0%, #be185d 100%)',
  'linear-gradient(135deg, #22c55e 0%, #15803d 100%)',
  'linear-gradient(135deg, #06b6d4 0%, #0e7490 100%)',
  'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)',
];

export function avatarGradient(memberId: number): string {
  // Plain |0 keeps everything in 32-bit integer space; abs() guards
  // against negative ids defensively (unlikely but cheap).
  const idx = Math.abs((memberId | 0)) % GRADIENTS.length;
  return GRADIENTS[idx];
}
